import { z } from 'zod'

// sensor id should be 16 characters of hex
export type SensorId = string & { __brand: 'SensorId' }

// sensorId should be 16 characters of hex, coerce to uppercase
export const sensorId = z
  .string()
  .length(16)
  .toUpperCase()
  .regex(/^[0-9A-F]+$/, 'Must be uppercase hexadecimal')
